import React, { useEffect, useState } from 'react';
import { ButtonText, ButtonWrapper } from './styles';
import useLocalization from '../../../../hooks/useLocalization';
export function CourseRouteButton(_a) {
    var courseRoute = _a.courseRoute, lmsButtonLabel = _a.lmsButtonLabel, isDetailsPath = _a.isDetailsPath, hasUnderline = _a.hasUnderline;
    var _b = useLocalization(), t = _b.t, language = _b.language;
    return (React.createElement(ButtonWrapper, { onClick: function () { return window.open(courseRoute, '_self'); } },
        React.createElement(ButtonText, { hasUnderline: hasUnderline }, isDetailsPath ? t('lms.detailButton') : t('lms.goBack'))));
}
//# sourceMappingURL=courseRouteButton.js.mapimport React, { useEffect, useState } from 'react';
import { ButtonText, ButtonWrapper } from './styles';
import useLocalization from '../../../../hooks/useLocalization';
export function CourseRouteButton(_a) {
    var courseRoute = _a.courseRoute, lmsButtonLabel = _a.lmsButtonLabel, isDetailsPath = _a.isDetailsPath, hasUnderline = _a.hasUnderline;
    var _b = useLocalization(), t = _b.t, language = _b.language;
    return (React.createElement(ButtonWrapper, { onClick: function () { return window.open(courseRoute, '_self'); } },
        React.createElement(ButtonText, { hasUnderline: hasUnderline }, isDetailsPath ? t('lms.detailButton') : t('lms.goBack'))));
}
//# sourceMappingURL=courseRouteButton.js.map